"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.put = exports.getList = exports.get = void 0;
const validation_1 = __importDefault(require("../../../../../validation"));
const rules_1 = __importDefault(require("../../../../../validation/rules"));
const getParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
    recommendedActionId: validation_1.default.rules.string().required().label('Recommended Action ID'),
};
const getListParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
};
const getListQueryRules = { privacyIssueId: validation_1.default.rules.string().required().label('Privacy Issue ID') };
const putParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
    recommendedActionId: validation_1.default.rules.string().required().label('Recommended Action ID'),
};
const putBodyRules = { answerIds: rules_1.default.array().of(rules_1.default.string()).required().label('Answer IDs') };
const getParams = {
    rules: getParamRules,
    schema: validation_1.default.schema(getParamRules),
};
const getListParams = {
    rules: getListParamRules,
    schema: validation_1.default.schema(getListParamRules),
};
const getListQuery = {
    rules: getListQueryRules,
    schema: validation_1.default.schema(getListQueryRules),
};
const putParams = {
    rules: putParamRules,
    schema: validation_1.default.schema(putParamRules),
};
const putBody = {
    rules: putBodyRules,
    schema: validation_1.default.schema(putBodyRules),
};
exports.get = { params: getParams };
exports.getList = {
    params: getListParams,
    query: getListQuery,
};
exports.put = {
    params: putParams,
    body: putBody,
};
